import http from '@/utils/http'

// 获取apple pay Token
export function postGoogleDecryptToken(id, data) {
  return http.post(`/checkout/google-pay/decrypt-token/${id}`, data)
}
